<template>
    <div class="horizontal grow gallery-container" style="min-width: 700px; width: 50vw; height: 70vh">
        <div id="info-container">
            <div>
                <p class="section-title">{{ $t('NEW_SERVER_CONFIG') }}</p>
                <div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Name') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="config.name" type="text" :placeholder="$t('Name')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Address') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="config.address" type="text" :placeholder="$t('Address')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Profile') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <select id="usersid">
                                    <option v-for="user in users" :key="user.id">
                                        {{ user.publicName }} <span v-if="user.currentServer != ''">({{ user.currentServer }})</span>
                                    </option>
                                </select>
                            </td>
                        </tr>
                    </div>
                    <div>
                        <div class="error" v-if="error != ''">{{ error }}</div>
                    </div>
                </div>
            </div>
            <div style="align-self: center;">
                <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '../Button.vue';
import Select from '../Select.vue'

import { getServerUsers } from '@api';

export default {
    props: {
        existing: {
            typeof: Object,
            required: false
        }
    },
    components: {
        Button,
        Select
    },
    data() {
        return {
            users: [],
            config: {
                name: '',
                address: ''
            },
            error: '',
        }
    },
    methods: {
        async getData() {
            this.users = await getServerUsers();
        },
        async save() {
            console.log('save clicked')
        }
    },
    mounted: async function () {
        this.getData()
    }
}
</script>

<style scoped>

.error {
    text-align: left !important;
    color: #FD8282;
    font-size: 11px;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

#info-container {
    width: 50%;
    padding: 20px;

    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;

    justify-content: space-between;
    display: flex;
    flex-direction: column;
}

#systems-container {
    width: 50%;
    align-items: center;
    justify-content: center;
    /* margin: auto; */
}

.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.section-title {
    font-weight: bold;
}

input[type=text], input[type="email"], input[type="password"] {
    border: unset;
    border-bottom: 1px solid #0095b233;
    width: 100%;
}

input[type=text]:focus, input[type="email"]:focus, input[type="password"]:focus {
    border-bottom: 1px solid #0095b2;
    outline: none;
}

select {
    border: none;
    width: 100%;
}

select:focus {
    outline: none;
    border-bottom: 1px solid #0095b2;
}

option {
    padding: 4px;
}

option:checked {
    background: #347C93;
    color: white;
}

.alarm-type-card {
	display: flex;
	align-items: center;
	background-color: rgba(243, 243, 243, 1);
	cursor: pointer;
	padding: 0 12px;
	border: 1px solid rgba(224, 224, 224, 1);
	border-radius: 5px;
	height: 30px;
	margin: 5px 5px;
	box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);
	-ms-flex-item-align: center;
	text-align: left;
	background-color: white;
}

.alarm-type-card:hover {
	background-color: rgba(0, 125, 149, 0.1);
	color: black;
}

.selected-alarm-type {
	background-color: rgba(0, 125, 149, 1);
	color: white;
}

.disablegrid {
    pointer-events: none;
    opacity: 0.4;
}

</style>


// WEBPACK FOOTER //
// src/components/Cloud/AddCloudModal.vue